






























































import Vue from "vue";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default Vue.extend({
  name: "ProductCategory",
  data() {
    return {
      perPage: 5
    };
  },
  methods: {
    handleHideModal() {
      this.hideModal();
      this.fechListProduct();
    },
    openModalAdd() {
      this.showModalCategoryAdd();
    },
    onPageChange(page: number) {
      this.pageChange(page);
    },
    ...mapMutations({
      hideModal: "productCategory/hideModal"
    }),
    ...mapActions({
      pageChange: "productCategory/pageChange",
      deleteCategory: "productCategory/deleteCategory",
      showModalCategoryAdd: "productCategory/showModalCategoryAdd",
      showModalCategoryEidt: "productCategory/showModalCategoryEidt",
      fechListProduct: "product/fechListProduct"
    })
  },
  computed: {
    ...mapGetters({
      isModal: "productCategory/isModal",
      data: "productCategory/categorys",
      loading: "productCategory/loading",
      count: "productCategory/count"
    })
  }
});
